import React from "react";
import { IconButton } from "@mui/material";
import { Share } from "@mui/icons-material";

const ShareButton = ({ title = "", description = "", wrapperClass }) => {
  const pageUrl = window.location.href;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: description,
          url: pageUrl,
        });
      } catch (error) {
        console.error("Some error occured! Please try again");
      }
    } else {
      console.error("This service is not supported in your browser!");
    }
  };

  return (
    <div className={wrapperClass}>
      <IconButton onClick={handleShare}>
        <Share />
      </IconButton>
    </div>
  );
};

export default ShareButton;
